import { render, staticRenderFns } from "./AssayViewModeToggle.vue?vue&type=template&id=12dfd48a"
import script from "./AssayViewModeToggle.vue?vue&type=script&lang=js"
export * from "./AssayViewModeToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports